import { defineMessages, useIntl } from "react-intl";
import {
  ConditionType,
  DeviceType,
  DayOfWeek,
  MatchMode,
  SeasonType,
  Hemisphere,
} from "./shared/domain/orchestrationCriteria.entity";
import { GlobalActionKey } from "./shared/domain/globalAction.types";

export const orchestratorMessages = defineMessages({
  [ConditionType.OCCUPANCY]: {
    id: "orchestrator.conditionType.occupancy",
    defaultMessage: "Occupancy",
  },
  [ConditionType.CHECK_IN_DAY]: {
    id: "orchestrator.conditionType.checkInDay",
    defaultMessage: "Check-in day",
  },
  [ConditionType.CHECK_OUT_DAY]: {
    id: "orchestrator.conditionType.checkOutDay",
    defaultMessage: "Check-out day",
  },
  [ConditionType.LENGTH_OF_STAY]: {
    id: "orchestrator.conditionType.lengthOfStay",
    defaultMessage: "Length of stay",
  },
  [ConditionType.BOOKING_WINDOW]: {
    id: "orchestrator.conditionType.bookingWindow",
    defaultMessage: "Booking window",
  },
  [ConditionType.TRAVEL_WINDOW]: {
    id: "orchestrator.conditionType.travelWindow",
    defaultMessage: "Travel window",
  },
  [ConditionType.NUMBER_OF_ROOMS]: {
    id: "orchestrator.conditionType.numberOfRooms",
    defaultMessage: "Number of rooms",
  },
  [ConditionType.DEVICE]: {
    id: "orchestrator.conditionType.device",
    defaultMessage: "Device",
  },
  [ConditionType.REFERRER]: {
    id: "orchestrator.conditionType.referrer",
    defaultMessage: "Referrer",
  },
  [ConditionType.UTM_SOURCE]: {
    id: "orchestrator.conditionType.utmSource",
    defaultMessage: "UTM source",
  },
  [ConditionType.ORIGIN]: {
    id: "orchestrator.conditionType.origin",
    defaultMessage: "Origin",
  },
  [ConditionType.SEASON]: {
    id: "orchestrator.conditionType.season",
    defaultMessage: "Season",
  },
});

export const criteriaModalMessages = defineMessages({
  addConditionTitle: {
    id: "orchestrator.criteriaModal.addConditionTitle",
    defaultMessage: "Add condition",
  },
  editConditionTitle: {
    id: "orchestrator.criteriaModal.editConditionTitle",
    defaultMessage: "Edit condition",
  },
  conditionType: {
    id: "orchestrator.criteriaModal.conditionType",
    defaultMessage: "Condition type",
  },
  selectCondition: {
    id: "orchestrator.criteriaModal.selectCondition",
    defaultMessage: "Select a condition",
  },
  values: {
    id: "orchestrator.criteriaModal.values",
    defaultMessage: "Values",
  },
  valuesHelper: {
    id: "orchestrator.criteriaModal.valuesHelper",
    defaultMessage: "Enter values separated by commas",
  },
  valuesPlaceholder: {
    id: "orchestrator.criteriaModal.valuesPlaceholder",
    defaultMessage: "value1, value2, value3",
  },
  startDate: {
    id: "orchestrator.criteriaModal.startDate",
    defaultMessage: "Start date",
  },
  endDate: {
    id: "orchestrator.criteriaModal.endDate",
    defaultMessage: "End date",
  },
  activeDays: {
    id: "orchestrator.criteriaModal.activeDays",
    defaultMessage: "Active days",
  },
  min: {
    id: "orchestrator.criteriaModal.min",
    defaultMessage: "Minimum",
  },
  maxOptional: {
    id: "orchestrator.criteriaModal.maxOptional",
    defaultMessage: "Maximum (optional)",
  },
  noLimit: {
    id: "orchestrator.criteriaModal.noLimit",
    defaultMessage: "No limit",
  },
  deviceTypes: {
    id: "orchestrator.criteriaModal.deviceTypes",
    defaultMessage: "Device types",
  },
  seasons: {
    id: "orchestrator.criteriaModal.seasons",
    defaultMessage: "Seasons",
  },
  hemisphere: {
    id: "orchestrator.criteriaModal.hemisphere",
    defaultMessage: "Hemisphere",
  },
  add: {
    id: "orchestrator.criteriaModal.add",
    defaultMessage: "Add",
  },
  update: {
    id: "orchestrator.criteriaModal.update",
    defaultMessage: "Update",
  },
  cancel: {
    id: "orchestrator.criteriaModal.cancel",
    defaultMessage: "Cancel",
  },
  occupancyFilterLabel: {
    id: "orchestrator.criteriaModal.occupancyFilterLabel",
    defaultMessage: "Filter by type",
  },
  adults: {
    id: "orchestrator.criteriaModal.adults",
    defaultMessage: "Adults",
  },
  children: {
    id: "orchestrator.criteriaModal.children",
    defaultMessage: "Children",
  },
  juniors: {
    id: "orchestrator.criteriaModal.juniors",
    defaultMessage: "Juniors",
  },
  seniors: {
    id: "orchestrator.criteriaModal.seniors",
    defaultMessage: "Seniors",
  },
  babies: {
    id: "orchestrator.criteriaModal.babies",
    defaultMessage: "Babies",
  },
  selectAll: {
    id: "orchestrator.criteriaModal.selectAll",
    defaultMessage: "Select all",
  },
  deselectAll: {
    id: "orchestrator.criteriaModal.deselectAll",
    defaultMessage: "Deselect all",
  },
  selectedCount: {
    id: "orchestrator.criteriaModal.selectedCount",
    defaultMessage: "{count} selected",
  },
  noMatchingOccupations: {
    id: "orchestrator.criteriaModal.noMatchingOccupations",
    defaultMessage: "No occupations match the filters",
  },
  noDaysSelectedHelper: {
    id: "orchestrator.criteriaModal.noDaysSelectedHelper",
    defaultMessage: "If none is selected, it will apply to all days.",
  },
  hourRange: {
    id: "orchestrator.criteriaModal.hourRange",
    defaultMessage: "Hour range",
  },
  hourRangeDescription: {
    id: "orchestrator.criteriaModal.hourRangeDescription",
    defaultMessage: "If specified, the condition will only apply within this hour range.",
  },
  startHour: {
    id: "orchestrator.criteriaModal.startHour",
    defaultMessage: "Start hour",
  },
  endHour: {
    id: "orchestrator.criteriaModal.endHour",
    defaultMessage: "End hour",
  },
  timezone: {
    id: "orchestrator.criteriaModal.timezone",
    defaultMessage: "Timezone",
  },
  selectTimezone: {
    id: "orchestrator.criteriaModal.selectTimezone",
    defaultMessage: "Select timezone...",
  },
  bookingWindows: {
    id: "orchestrator.criteriaModal.bookingWindows",
    defaultMessage: "Booking windows",
  },
  travelWindows: {
    id: "orchestrator.criteriaModal.travelWindows",
    defaultMessage: "Travel windows",
  },
  windowLabel: {
    id: "orchestrator.criteriaModal.windowLabel",
    defaultMessage: "Window {index}",
  },
  removeWindow: {
    id: "orchestrator.criteriaModal.removeWindow",
    defaultMessage: "Remove",
  },
  addWindow: {
    id: "orchestrator.criteriaModal.addWindow",
    defaultMessage: "+ Add window",
  },
  loading: {
    id: "orchestrator.criteriaModal.loading",
    defaultMessage: "Loading...",
  },
  defaultOption: {
    id: "orchestrator.criteriaModal.defaultOption",
    defaultMessage: "Default",
  },
});

export const actionModalMessages = defineMessages({
  addActionTitle: {
    id: "orchestrator.criteriaModal.addActionTitle",
    defaultMessage: "Add action",
  },
  editActionTitle: {
    id: "orchestrator.criteriaModal.editActionTitle",
    defaultMessage: "Edit action",
  },
  selectAction: {
    id: "orchestrator.actionModal.selectAction",
    defaultMessage: "Select an action",
  },
  invalidURLFormat: {
    id: "orchestrator.actionModal.invalidURLFormat",
    defaultMessage: "Invalid URL format",
  },
  enabled: {
    id: "orchestrator.actionModal.enabled",
    defaultMessage: "Enabled",
  },
  value: {
    id: "orchestrator.actionModal.value",
    defaultMessage: "Value",
  },
  valueHelper: {
    id: "orchestrator.actionModal.valueHelper",
    defaultMessage: "Enter values separated by commas",
  },
  actionType: {
    id: "orchestrator.actionModal.actionType",
    defaultMessage: "Action type",
  },
  update: {
    id: "orchestrator.actionModal.update",
    defaultMessage: "Update",
  },
  add: {
    id: "orchestrator.actionModal.add",
    defaultMessage: "Add",
  },
  cancel: {
    id: "orchestrator.actionModal.cancel",
    defaultMessage: "Cancel",
  },
  loadingSegments: {
    id: "orchestrator.actionModal.loadingSegments",
    defaultMessage: "Loading segments...",
  },
  noSegmentsAvailable: {
    id: "orchestrator.actionModal.noSegmentsAvailable",
    defaultMessage: "No segments available",
  },
  valuePlaceholder: {
    id: "orchestrator.actionModal.valuePlaceholder",
    defaultMessage: "value1, value2, value3",
  },
  urlPlaceholder: {
    id: "orchestrator.actionModal.urlPlaceholder",
    defaultMessage: "https://example.com",
  },
  enterValue: {
    id: "orchestrator.actionModal.enterValue",
    defaultMessage: "Enter value",
  },
  yes: {
    id: "orchestrator.actionModal.yes",
    defaultMessage: "Yes",
  },
  no: {
    id: "orchestrator.actionModal.no",
    defaultMessage: "No",
  },
});

export const actionLabelMessages = defineMessages<GlobalActionKey>({
  displayMode: {
    id: "orchestrator.action.displayMode",
    defaultMessage: "Display mode",
  },
  accommodationResultsFormat: {
    id: "orchestrator.action.accommodationResultsFormat",
    defaultMessage: "Accommodation results format",
  },
  accommodationSortingCriteria: {
    id: "orchestrator.action.accommodationSortingCriteria",
    defaultMessage: "Accommodation order",
  },
  bookingAdvantagesPosition: {
    id: "orchestrator.action.bookingAdvantagesPosition",
    defaultMessage: "Booking advantages position",
  },
  engineHighlightReelOrder: {
    id: "orchestrator.action.engineHighlightReelOrder",
    defaultMessage: "Highlights reel",
  },
  showExtrasConfiguration: {
    id: "orchestrator.action.showExtrasConfiguration",
    defaultMessage: "Show extras configuration",
  },
  priceCalendar: {
    id: "orchestrator.action.priceCalendar",
    defaultMessage: "Price calendar",
  },
  enableLoyalty: {
    id: "orchestrator.action.enableLoyalty",
    defaultMessage: "Enable loyalty",
  },
  bookAndJoinType: {
    id: "orchestrator.action.bookAndJoinType",
    defaultMessage: "Book&Join type",
  },
  addMandatoryExtrasToInventoryRate: {
    id: "orchestrator.action.addMandatoryExtrasToInventoryRate",
    defaultMessage: "Add mandatory extras rate to room selection",
  },
  showMandatoryExtras: {
    id: "orchestrator.action.showMandatoryExtras",
    defaultMessage: "Show mandatory extras",
  },
  showEngineDiscount: {
    id: "orchestrator.action.showEngineDiscount",
    defaultMessage: "Show engine discount",
  },
  unavailableURL: {
    id: "orchestrator.action.unavailableURL",
    defaultMessage: "Unavailable URL",
  },
  buttonRoundType: {
    id: "orchestrator.action.buttonRoundType",
    defaultMessage: "Button round type",
  },
  tagRoundType: {
    id: "orchestrator.action.tagRoundType",
    defaultMessage: "Tag round type",
  },
  bookingFormRoundType: {
    id: "orchestrator.action.bookingFormRoundType",
    defaultMessage: "Booking form round type",
  },
  cardRoundType: {
    id: "orchestrator.action.cardRoundType",
    defaultMessage: "Card round type",
  },
  formRoundType: {
    id: "orchestrator.action.formRoundType",
    defaultMessage: "Form round type",
  },
  paymentTickers: {
    id: "orchestrator.action.paymentTickers",
    defaultMessage: "Payment tickers",
  },
  promotionalcode: {
    id: "orchestrator.action.promotionalcode",
    defaultMessage: "Promotional code",
  },
  messageCode: {
    id: "orchestrator.action.messageCode",
    defaultMessage: "Message code",
  },
  tab: {
    id: "orchestrator.action.tab",
    defaultMessage: "Tab",
  },
  segment: {
    id: "orchestrator.action.segment",
    defaultMessage: "Segment",
  },
});

export function useActionLabels(): Record<GlobalActionKey, string> {
  const intl = useIntl();
  return Object.fromEntries(
    Object.entries(actionLabelMessages).map(([key, descriptor]) => [
      key,
      intl.formatMessage(descriptor),
    ])
  ) as Record<GlobalActionKey, string>;
}

export function useConditionTypeLabels(): Record<ConditionType, string> {
  const intl = useIntl();
  return Object.fromEntries(
    Object.values(ConditionType).map(type => [type, intl.formatMessage(orchestratorMessages[type])])
  ) as Record<ConditionType, string>;
}

export const deviceTypeLabelMessages = defineMessages<DeviceType>({
  [DeviceType.DEVICE_TYPE_UNSPECIFIED]: {
    id: "orchestrator.deviceType.unspecified",
    defaultMessage: "Unspecified",
  },
  [DeviceType.DEVICE_TYPE_DESKTOP]: {
    id: "orchestrator.deviceType.desktop",
    defaultMessage: "Desktop",
  },
  [DeviceType.DEVICE_TYPE_MOBILE]: {
    id: "orchestrator.deviceType.mobile",
    defaultMessage: "Mobile",
  },
  [DeviceType.DEVICE_TYPE_TABLET]: {
    id: "orchestrator.deviceType.tablet",
    defaultMessage: "Tablet",
  },
});

export function useDeviceTypeLabels(): Record<DeviceType, string> {
  const intl = useIntl();
  return Object.fromEntries(
    Object.entries(deviceTypeLabelMessages).map(([key, descriptor]) => [
      key,
      intl.formatMessage(descriptor),
    ])
  ) as Record<DeviceType, string>;
}

export const seasonTypeLabelMessages = defineMessages<SeasonType>({
  [SeasonType.SEASON_TYPE_UNSPECIFIED]: {
    id: "orchestrator.seasonType.unspecified",
    defaultMessage: "Unspecified",
  },
  [SeasonType.SPRING]: {
    id: "orchestrator.seasonType.spring",
    defaultMessage: "Spring",
  },
  [SeasonType.SUMMER]: {
    id: "orchestrator.seasonType.summer",
    defaultMessage: "Summer",
  },
  [SeasonType.AUTUMN]: {
    id: "orchestrator.seasonType.autumn",
    defaultMessage: "Autumn",
  },
  [SeasonType.WINTER]: {
    id: "orchestrator.seasonType.winter",
    defaultMessage: "Winter",
  },
});

export function useSeasonTypeLabels(): Record<SeasonType, string> {
  const intl = useIntl();
  return Object.fromEntries(
    Object.entries(seasonTypeLabelMessages).map(([key, descriptor]) => [
      key,
      intl.formatMessage(descriptor),
    ])
  ) as Record<SeasonType, string>;
}

export const hemisphereLabelMessages = defineMessages<Hemisphere>({
  [Hemisphere.HEMISPHERE_UNSPECIFIED]: {
    id: "orchestrator.hemisphere.unspecified",
    defaultMessage: "Unspecified",
  },
  [Hemisphere.NORTHERN]: {
    id: "orchestrator.hemisphere.northern",
    defaultMessage: "Northern",
  },
  [Hemisphere.SOUTHERN]: {
    id: "orchestrator.hemisphere.southern",
    defaultMessage: "Southern",
  },
});

export function useHemisphereLabels(): Record<Hemisphere, string> {
  const intl = useIntl();
  return Object.fromEntries(
    Object.entries(hemisphereLabelMessages).map(([key, descriptor]) => [
      key,
      intl.formatMessage(descriptor),
    ])
  ) as Record<Hemisphere, string>;
}

export const dayOfWeekLabelMessages = defineMessages<DayOfWeek>({
  [DayOfWeek.MONDAY]: {
    id: "orchestrator.dayOfWeek.monday",
    defaultMessage: "Monday",
  },
  [DayOfWeek.TUESDAY]: {
    id: "orchestrator.dayOfWeek.tuesday",
    defaultMessage: "Tuesday",
  },
  [DayOfWeek.WEDNESDAY]: {
    id: "orchestrator.dayOfWeek.wednesday",
    defaultMessage: "Wednesday",
  },
  [DayOfWeek.THURSDAY]: {
    id: "orchestrator.dayOfWeek.thursday",
    defaultMessage: "Thursday",
  },
  [DayOfWeek.FRIDAY]: {
    id: "orchestrator.dayOfWeek.friday",
    defaultMessage: "Friday",
  },
  [DayOfWeek.SATURDAY]: {
    id: "orchestrator.dayOfWeek.saturday",
    defaultMessage: "Saturday",
  },
  [DayOfWeek.SUNDAY]: {
    id: "orchestrator.dayOfWeek.sunday",
    defaultMessage: "Sunday",
  },
});

export function useDayOfWeekLabels(): Record<DayOfWeek, string> {
  const intl = useIntl();
  return Object.fromEntries(
    Object.entries(dayOfWeekLabelMessages).map(([key, descriptor]) => [
      key,
      intl.formatMessage(descriptor),
    ])
  ) as Record<DayOfWeek, string>;
}

export const matchModeLabelMessages = defineMessages<MatchMode>({
  [MatchMode.MATCH_MODE_UNSPECIFIED]: {
    id: "orchestrator.matchMode.unspecified",
    defaultMessage: "Unspecified",
  },
  [MatchMode.ALL]: {
    id: "orchestrator.matchMode.all",
    defaultMessage: "Match ALL conditions",
  },
  [MatchMode.ANY]: {
    id: "orchestrator.matchMode.any",
    defaultMessage: "Match ANY condition",
  },
});

export function useMatchModeLabels(): Record<MatchMode, string> {
  const intl = useIntl();
  return Object.fromEntries(
    Object.entries(matchModeLabelMessages).map(([key, descriptor]) => [
      key,
      intl.formatMessage(descriptor),
    ])
  ) as Record<MatchMode, string>;
}
